import React from 'react';

type LibraryCountCardProps = {
  label: string;
  value: React.ReactNode;
  hint: React.ReactNode;
  /** A `.settings-meta-card` tone: neutral, info, warn or ok. */
  tone: string;
  /** Says what choosing the card does, e.g. "Filter by Open". */
  ariaLabel: string;
  onSelect: () => void;
};

/**
 * One count in a library hero's `.settings-meta-card` row that filters the list when chosen
 * (click, Enter or Space). Shared by the Service Tickets and Installation Jobs libraries.
 */
export default function LibraryCountCard({ label, value, hint, tone, ariaLabel, onSelect }: LibraryCountCardProps) {
  return (
    <div
      className="settings-meta-card"
      data-tone={tone}
      style={{ cursor: 'pointer' }}
      onClick={onSelect}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
    >
      <span className="settings-meta-card__label">{label}</span>
      <span className="settings-meta-card__value">{value}</span>
      <span className="settings-meta-card__hint">{hint}</span>
    </div>
  );
}
